<template>
  <v-container fluid>
    <!-- CONTENT -->
    <v-flex>
      <v-row class="mb-6 px-6" align="center" justify="start">
        <v-col cols="7">
          <span class="text-h5">
            {{ $t('license.title') }}
          </span>
        </v-col>
      </v-row>
      <v-card v-if="license" class="mb-6 pa-5">
        <v-container>
          <v-row align="center">
            <v-col cols="4">
              {{ $t('license.content.licenseType') }}
            </v-col>
            <v-col cols="8">
              <div class="d-inline-flex">{{ license.licenseType }}</div>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col cols="4">
              {{ $t('license.content.productOwner') }}
            </v-col>
            <v-col cols="8">
              <div class="d-inline-flex">{{ license.productOwner }}</div>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col cols="4">
              {{ $t('license.content.productKey') }}
            </v-col>
            <v-col cols="8">
              <div class="d-inline-flex">{{ license.productKey }}</div>
            </v-col>
          </v-row>
        </v-container>
      </v-card>

      <v-card v-if="license" class="mb-6 pa-5">
        <v-container>
          <v-row align="center">
            <v-col cols="4">
              {{ $t('license.content.expiresAt') }}
            </v-col>
            <v-col cols="8">
              <div class="d-inline-flex">{{ license.expiresAt }}</div>
            </v-col>
          </v-row>

          <v-row align="center">
            <v-col cols="4">
              {{ $t('license.content.remaining') }}
            </v-col>
            <v-col v-if="license.expiresAt" cols="8">
              <div class="d-inline-flex">{{ calcDaysleft( license.expiresAt) }} </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card>

      <v-card v-if="license" class="mb-6 pa-5">
        <v-container>
          <v-row align="center">
            <v-col cols="4">
              {{ $t('license.content.userLimit') }}
            </v-col>
            <v-col cols="8">
              <div class="d-inline-flex">{{ license.userLimit }}</div>
            </v-col>
          </v-row>

          <v-row align="center">
            <v-col cols="4">
              {{ $t('license.content.currentUserNumber') }}
            </v-col>
            <v-col cols="8">
              <div class="d-inline-flex">{{ license.currentUserCount }}</div>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-flex>
  </v-container>
</template>

<script>
import server from '@/services/api/server'
import { showToastError } from '@/event-bus'

export default {
  name: 'License',

  data() {
    return {
      versionInfo: null,
      license: null
    }
  },

  async mounted() {
    try {
      this.license = await server.getLicenseInfo()
    } catch (error) {
      const errorMsg = this.getErrorMessage(error)
      showToastError(errorMsg)
    }
  },

  methods: {
    calcDaysleft(to) {
      const fromDate = new Date()
      const toDate = new Date(to)
      const daysBetween = Math.floor((toDate.getTime() - fromDate.getTime()) / (1000 * 3600 * 24))

      return daysBetween
    }
  }
}
</script>

<style>
</style>
